'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

var Resx = (0, _localize2.default)('Common', 'App', 'Messages');

var currentOrdering = null;

function initNestable() {
    $('.cmsPageSectionFilesNestable').nestable({
        dragClass: 'dd-dragel nestable',
        maxDepth: 1
    }).on('change', function (e) {
        var ordering = $('.cmsPageSectionFilesNestable').nestable('serialize');

        // since this event may be fired multiple times during a single update, we should check whether the update is really necessary
        var saveOrdering = false;

        if (currentOrdering !== null) {
            if (currentOrdering.length !== ordering.length) {
                saveOrdering = true;
            } else {
                for (var i = 0; i < ordering.length; i++) {
                    if (ordering[i].id !== currentOrdering[i].id) {
                        saveOrdering = true;
                        break;
                    }
                }
            }
        } else {
            saveOrdering = true;
        }

        if (saveOrdering) {
            currentOrdering = ordering;
            _notify2.default.info(Resx.App.CmsPageFileOrderInfo);
            return;
        }
    });
}

function setupButtonEvents() {
    $(document).on("click", 'a[cms-page-section-file-item-button-delete]', function (e) {
        e.preventDefault();
        var $buttonClicked = $(this);
        _message2.default.confirm(Resx.App.CmsPageFileDeleteConfirmation, Resx.Messages.ConfirmTitle, function (isConfirmed) {
            if (isConfirmed) {
                $buttonClicked.closest('li[data-id]').remove();
                _notify2.default.success(Resx.App.CmsPageFileDeleteConfirmed);
            }
        });
    });
}

function cmsPageSectionFilesOnLoad() {
    initNestable();
    setupButtonEvents();
}

module.exports = exports.default = function () {
    cmsPageSectionFilesOnLoad();

    window.linksoft.setupCmsSectionFiles = function () {
        cmsPageSectionFilesOnLoad();
    };
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cmsPageSectionFiles.js
// module id = 415
// module chunks = 0